
import Modal from '../modal/modal'
import React from 'react';
import { inject, observer } from "mobx-react";
import Language from '../language/language'
import { Button } from 'antd'


@inject('gameStore', 'languageStore')
@observer
export default class SubmitLimitTip extends React.Component {
  submit = () => {
    if (this.props.submit) {
      this.props.submit()
      this.props.gameStore.submitLimit.submitTimeReservation && this.props.gameStore.submitLimit.submitTimeReservation.submitForm();
    }
  }
  close = () => {
    if (this.props.close) {
      this.props.close()
    }
  }

  render () {
    const lang = this.props.languageStore.lang
    return (
      <div className="sumit-limit-tip-modal">
        <Modal class="sumit-limit-tip" title={<Language resource="CONFIRM_SUBMIT_FORM" />} state={this.props.gameStore.submitLimit.show}  close={this.close} >
          <div className="confirm-tip">
            {lang === 'zh'
              ? `您已提交${this.props.gameStore.submitLimit.submitSum}次${this.props.gameStore.submitLimit.title}，剩余${this.props.gameStore.submitLimit.limitSum - this.props.gameStore.submitLimit.submitSum}次提交机会，请确认是否提交此次${this.props.gameStore.submitLimit.title}？提交后，您将剩余${this.props.gameStore.submitLimit.limitSum - this.props.gameStore.submitLimit.submitSum - 1}次${this.props.gameStore.submitLimit.title}提交机会。`
              : `You have submitted ${this.props.gameStore.submitLimit.submitSum} time${ this.props.gameStore.submitLimit.submitSum > 1 ? 's' : ''}, remaining ${this.props.gameStore.submitLimit.limitSum - this.props.gameStore.submitLimit.submitSum} time${ this.props.gameStore.submitLimit.limitSum - this.props.gameStore.submitLimit.submitSum ? 's' : ''}. Please confirm to submit ${this.props.gameStore.submitLimit.title}. After submitting, you will have ${this.props.gameStore.submitLimit.limitSum - this.props.gameStore.submitLimit.submitSum - 1} time${ this.props.gameStore.submitLimit.limitSum - this.props.gameStore.submitLimit.submitSum - 1 ? 's' : ''} remaining.`
            }
          </div>
          <div className="operate">
            <Button onClick={this.submit}>
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/controlCenter/submitLimitTip.js